import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import {verificaCache} from '../../../verificaCache';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';



class CupomDesconto extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: 'loading',
      showTable: false,

      errorRequest: false,
      msgErrorRequest: '',
      successRequest: false,
      msgSuccessRequest: '',

      modalConfirmOpen: false,
      modalConfirmButtonLoading: false,
      deleteCupomId: null,
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      theadTh:{
        height: 35,
      },
      inputSearch: {
        marginLeft: 8,
        flex: 1,
      },
    }

  }

  componentDidMount() {
    verificaCache(function (vc) {
      if (vc.erro === false) {
        this.fullScreenModalFn();

        if (configBase.moduloCupomDesconto === true)
          this.getData();
        else {
          let state = this.state;
          state.data = 'error';
          this.setState(state);
        }
      }
      else
        this.setError(vc.mensagem);
    }.bind(this));
  }

  getData() {
    let url = configBase.api + 'Cupons/getFormatted?access_token='+localStorage.getItem('planos_t');

    axios.get(url)
    .then((response) => {
      let state = this.state;

      if (response.data.length === 0)
        state.data = 'zero';
      else
        this.setColorStatus(response.data);

      if (state.showTable === false) {
        state.showTable = true;

        $(document).ready( function () {
          let table = $('#table_id').DataTable({
            "dom": 'rtip',// Exibe {processing}{table}{information}{pagination}
            "language": {
              "url": `${process.env.PUBLIC_URL}/plugins/datatables/Portuguese-Brasil.lang`
            },
            columnDefs: [
              { type: 'date-uk', targets: 2 },
              { type: 'date-uk', targets: 3 },
            ],
            "infoCallback": function( settings, start, end, max, total, pre ) {// Quantidade por página
              document.getElementById('tablePageStart').innerHTML = start;
              document.getElementById('tablePageEnd').innerHTML = end;
              document.getElementById('tablePageTotal').innerHTML = total;
              return '';
            },
            pagingType: "simple",
            oLanguage: {
              oPaginate: {
                sNext: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path></svg>',
                sPrevious: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>'
              },
            },
            "scrollX": true,
          });

          $('#mySearchText').on( 'keyup', function () {
            table.search($('#mySearchText').val()).draw();
          } );

          // Quantidade por página
          $('#myLengthMenu').on( 'change', function () {
            table.page.len($('#myLengthMenu').val()).draw();
          } );

          $.extend( $.fn.dataTableExt.oSort, {
            "date-uk-pre": function ( a ) {
              if (a === null || a === "") {
                return 0;
              }
              var ukDatea = a.split('/');
              return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
            },
          
            "date-uk-asc": function ( a, b ) {
              return ((a < b) ? -1 : ((a > b) ? 1 : 0));
            },
          
            "date-uk-desc": function ( a, b ) {
              return ((a < b) ? 1 : ((a > b) ? -1 : 0));
            }
          } );
        });
      }

      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar cupons');
    }.bind(this));
  }

  setColorStatus(cupons) {
    let colors = {
      'true': {color: configBase.bgImplementadas, name: 'ATIVO'},
      'false': {color: configBase.bgCanceladas, name: 'INATIVO'},
    };

    let state = this.state;

    for (let i = 0; i < cupons.length; i++) {
      if (cupons[i].status === undefined) {
        cupons[i].color = colors.pendente.color;
        cupons[i].status = colors.pendente.name;
      }
      else {
        cupons[i].color = colors[cupons[i].status.toString()].color;
        cupons[i].status = colors[cupons[i].status.toString()].name;
      }
    }

    state.data = cupons;
  }

  sendAddSalesman() {
    this.props.history.push(`${process.env.PUBLIC_URL}/novocupomdesconto`);
  }

  editCupom(id) {
    this.props.history.push(`${process.env.PUBLIC_URL}/novocupomdesconto?cpd=${id}`);
  }

  fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960)
      state.fullScreenModal = false;
    else
      state.fullScreenModal = true;

    this.setState(state);
  }

  handleConfirmOpen(cupomId) {
    let state = this.state;
    state.modalConfirmOpen = true;
    state.deleteCupomId = cupomId;
    this.fullScreenModalFn();
  }

  handleConfirmClose () {
    let state = this.state;
    state.modalConfirmOpen = false;
    this.setState(state);
  }

  deleteCupom() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let url = configBase.api + 'Cupons/'+this.state.deleteCupomId+'?access_token='+localStorage.getItem('planos_t');

    axios.delete(url)
    .then(() => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.setSuccess('Cupom excluído com sucesso');
      this.handleConfirmClose();
      this.getData();
    })
    .catch(function () {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.setError('Problema encontrado ao excluir cupom');
    }.bind(this));
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  setSuccess(msg) {
    let state = this.state;
    state.successRequest = true;
    state.msgSuccessRequest = msg;
    this.setState(state);
  }

  successClose() {
    let state = this.state;
    state.successRequest = false;
    state.msgSuccessRequest = '';
    this.setState(state);
  }


  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="cupons" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  CUPONS
                </Typography>
              </Grid>

              <Grid item xs={12} sm={8} md={8} lg={8} className="botaoTituloAdd">
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria, marginRight: 5}}
                    startIcon={<AddIcon />}
                    size="small"
                    onClick={this.sendAddSalesman.bind(this)}
                    disabled={!configBase.moduloCupomDesconto}
                  >
                    CADASTRAR CUPOM
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Paper>

          <div id="cuponsConteudo" className="contentepanel">
          {
            this.state.data === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO CUPONS...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
            ) : (
              this.state.data === 'error' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                  {
                    configBase.moduloCupomDesconto === false ? (
                <Alert severity="error">Módulo de Cupom de Desconto não habilitado. Entre em contato com a Intelite Tecnologia</Alert>
                    ) : (
                <Alert severity="error">Problema ao buscar lista de cupons</Alert>
                    )
                  }
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
              ) : (
                this.state.data === 'zero' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Alert severity="info">Sem cupons cadastradas</Alert>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
                ) : (
            <div id="cuponsTabela">
              {/* ############# CSS PARA DATATABLE ############# */}
              <link
                rel="stylesheet" type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
              />
              <link
                rel="stylesheet" type="text/css"
                href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
              />
              {/* ############# CSS PARA DATATABLE ############# */}

              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} style={{marginBottom: 20}}>
                  <Paper elevation={1}>
                    <IconButton style={{padding: '6px 5px'}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      id="mySearchText"
                      style={this.styles.inputSearch}
                      placeholder="Pesquisar"
                      inputProps={{ 'aria-label': 'search google maps' }}
                    />
                  </Paper>
                </Grid>
              </Grid>

              <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                <thead style={{backgroundColor: configBase.corPrincipal}}>
                  <tr style={this.styles.theadTr}>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 10, fontWeight: 'bold'}}
                      >
                        CUPOM
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 10, fontWeight: 'bold'}}
                      >
                        VALOR
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 10, fontWeight: 'bold'}}
                      >
                        INICIO
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 10, fontWeight: 'bold'}}
                      >
                        FIM
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 10, fontWeight: 'bold'}}
                      >
                        STATUS
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 10, fontWeight: 'bold'}}
                      >
                        AÇÕES
                      </Typography>
                    </th>
                  </tr>
                </thead>

                <tbody>
                {this.state.data.map((item, index) =>
                  <tr
                    key={index}
                    className="row_table"
                    style={this.styles.theadTh}
                  >
                    <td style={{padding: 0, height: 35}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 10}}
                      >
                        {item.nome}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 10}}
                      >
                        {item.valor}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 10}}
                      >
                        {item.dataInicial}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 10}}
                      >
                        {item.dataFinal}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35}}>
                      <Typography variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 10}}
                      >
                        <span
                          style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}
                        >
                          {item.status}
                        </span>
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35}}>
                      <div>
                        <IconButton
                          aria-label="delete"
                          style={{padding: '8px 8px'}}
                          onClick={this.handleConfirmOpen.bind(this, item.id)}
                        >
                          <DeleteIcon />
                        </IconButton>

                        <IconButton
                          aria-label="delete"
                          style={{padding: '8px 8px'}}
                          onClick={this.editCupom.bind(this, item.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                )}
                </tbody>
              </table>

              <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                  <label htmlFor="myLengthMenu">Linhas por página: </label>
                  <select id="myLengthMenu" style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    {/* <option value="-1">Todas</option> */}
                  </select>
                  <span id="tablePageStart" style={{marginLeft: 15}}></span>-<span id="tablePageEnd"></span>
                  {' '}de{' '}
                  <span id="tablePageTotal"></span>
                </div>
              </div>
            </div>
                )
              )
            )
          }
          </div>

          <Dialog
            fullScreen={this.state.fullScreenModal}
            open={this.state.modalConfirmOpen}
            onClose={this.handleConfirmClose.bind(this)}
            aria-labelledby="i_modalConfirm"
          >
            <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>

            <DialogContent>
              <DialogContentText>
                O cupom será excluído permanentemente. Deseja continuar?
              </DialogContentText>
            </DialogContent>

            <DialogActions>
              <Button autoFocus color="primary"
                onClick={this.handleConfirmClose.bind(this)}
              >
                Fechar
              </Button>
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.deleteCupom.bind(this)}
              >
                SIM
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
            </DialogActions>
          </Dialog>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.successRequest} autoHideDuration={1000} onClose={this.successClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.successClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSuccessRequest}
            </MuiAlert>
          </Snackbar>
        </div>
      </MainLayout>
    );

  }

}

CupomDesconto.propTypes = {
  history: PropTypes.object
};

export default withRouter(CupomDesconto);